import React from 'react';
import { ZoomIn } from '../../../icons';

const ObjZoomIn = React.memo(props => <ZoomIn {...props} />);

export default ObjZoomIn;